import { IssueFront } from './issue.front';

export class FuturaLineaProformaFront {
    issueFrontAsociada: IssueFront;
    manoObra: number;
    material: number;
    rowIndex: number;
}
